import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

export type LanguageHelper = (namespace: string) => (key: string) => string;

export const useLanguageHelper = () => {
	const tResult = useTranslations('Result');
	const tBetType = useTranslations('BetType');
	return useCallback((namespace: string) => {
		switch (namespace) {
			case 'Result':
				return tResult.raw;
			case 'BetType':
				return tBetType.raw;
			default: 
				return () => '';
		}
	}, [tResult, tBetType]);
}